import React from 'react';
import { connect } from 'react-redux';
import { detect } from 'detect-browser';

import { STATIC_ROOT } from '../../../constants';
import { URL_CHROME, URL_FIREFOX, URL_EDGE } from '../../../services/toolbar/constants'; // Add URL_EDGE here

import { initToolbar } from '../../../services/toolbar/actions';

import ButtonComponent from '../../button/ButtonComponent';

class DownloadBlock extends React.Component {
    getToolbarUrl = () => {
        const browser = detect();
        switch (browser && browser.name) {
            case 'chrome':
                return URL_CHROME;
            case 'firefox':
                return URL_FIREFOX;
            case 'edge':
                return URL_EDGE;
            default:
                return '';
        }
    };

    getBrowser = () => {
        return detect().name;
    };

    traceDownload = browser => {
        const { initToolbar } = this.props;
        initToolbar(browser);
    };

    isBrowserNotSupported = () => ['ie', 'safari'].includes(this.getBrowser());

    render() {
        const { BUTTON_TEXT, AVAILABLE } = this.props;
        return (
            <React.Fragment>
                <div className="browser">
                    {!this.isBrowserNotSupported() && (
                        <a
                            href={this.getToolbarUrl()}
                            target={this.getBrowser() !== 'ie' ? '_blank' : ''}
                            onClick={() => this.traceDownload(this.getBrowser())}>
                            <ButtonComponent text={BUTTON_TEXT} color="main" />
                        </a>
                    )}
                    <div className="block">
                        <div>{AVAILABLE}</div>
                        <div>
                            <a
                                href={URL_CHROME}
                                title="Chrome"
                                target="_blank"
                                onClick={() => this.traceDownload('chrome')}>
                                <img
                                    src={`${STATIC_ROOT}/toolbars/chrome_24x24.png`}
                                    alt="chrome"
                                    width="24px"
                                    height="24px"
                                />
                            </a>
                            <a
                                href={URL_FIREFOX}
                                title="Firefox"
                                target="_blank"
                                onClick={() => this.traceDownload('firefox')}>
                                <img
                                    src={`${STATIC_ROOT}/toolbars/firefox_24x24.png`}
                                    alt="firefox"
                                    width="24px"
                                    height="24px"
                                />
                            </a>
                            <a
                                href={URL_EDGE}
                                title="Edge"
                                target="_blank"
                                onClick={() => this.traceDownload('edge')}>
                                <img
                                    src={`${STATIC_ROOT}/toolbars/edge.png`}
                                    alt="edge"
                                    width="24px"
                                    height="24px"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        BUTTON_TEXT: state.i18n.page.TOOLBAR.BUTTON_TEXT,
        AVAILABLE: state.i18n.page.TOOLBAR.AVAILABLE
    };
};

const mapDispatchtoProps = {
    initToolbar
};

export default connect(mapStateToProps, mapDispatchtoProps)(DownloadBlock);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/DownloadBlock.js